// https://vuex.vuejs.org/en/state.html

export default {
  drawer: null,
  routeList: [
    {
      to: "/",
      text: "Home"
    }
  ],
  config: {
    title: "Online Placement Assessment",
    subtitle: "Deakin University",
    welcome:
      "The purpose of this tool is to track students progress while out on placement. This tool allows for Students, Staff, Academics and Organisations to be involved in managing placements.",
    footer: "©2019 — Deakin OPA"
  }
};
